import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-sales-additional-information-experanza-client',
  templateUrl: './sales-additional-information-experanza-client.component.html'
})
export class SalesAdditionalInformationExperanzaClientComponent {
  @Input() visible: boolean = false;

  onClose() {
    this.visible = false;
  }
}
